module.exports = __webpack_public_path__ + "img/smile_warning.db64e54d.svg";